import { Navigate, Outlet } from "react-router";

import { useUser } from "@/client/services/user";

export const AdminObservabilityGuard = () => {
  // Use the same authoritative source as AuthGuard. Reading the Zustand store
  // directly raced hydration: on a cold deep-link load the store user lags one
  // render behind the /me query, so the guard saw `null`, judged "not admin",
  // and bounced the user to `/` before their real (admin) user resolved.
  // `loading` gates that window — exactly like AuthGuard.
  const { user, loading } = useUser({ force: true });

  if (loading) return null;

  if (!user) {
    return <Navigate replace to="/auth/login" />;
  }

  if (!user.isAdmin) {
    return <Navigate replace to="/" />;
  }

  return <Outlet />;
};
